type Actor = Readonly<{ thirdPartyId: string }>;

// The first avatar of an AvatarGroup stands above the others: the quotation
// emitters come first.
export const emittersFirst = <A extends Actor>(
  actors: readonly A[],
  emitters: readonly Actor[],
): readonly A[] => {
  const isEmitter = ({ thirdPartyId }: Actor) =>
    emitters.some((emitter) => emitter.thirdPartyId === thirdPartyId);

  return [
    ...actors.filter(isEmitter),
    ...actors.filter((actor) => !isEmitter(actor)),
  ];
};
